module.exports = __webpack_public_path__ + "/build/web/images/hero-testimonials@2x.bf3e1b4fa48f366b5688c402a8f4ae0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/hero-testimonials@2x.jpg
// module id = 149
// module chunks = 13